// ======================================================================
// File Name       : adaptive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../../constants/actionTypes/adaptive';

export function receivedAdaptiveMetaImportList(recordNum, importResultList) {
  return {
    type: ActionTypes.RECEIVED_ADAPTIVE_META_IMPORT_LIST,
    recordNum,
    importResultList,
  };
}

export function discriminationDegreeData(courseList) {
  return {
    type: ActionTypes.DISCRIMINATION_DEGREE_DATA,
    courseList,
  };
}
